import React, { memo } from 'react';
import { useForm } from 'react-hook-form';
import { classValidatorResolver } from '@hookform/resolvers/class-validator';
import { tagApi } from '@app/store';
import { TagDTO } from '@app/common';
import { Button, Form, Panel } from '@app/components';
import { TagForm } from './TagForm';
import { TagFormValues, transformStepFormValuesToPayload } from './tag-form.helpers';
import { useToast, useTriptych, useUpdateCardData } from '@app/hooks';

export const TagCreate = memo(() => {
  const toast = useToast();

  const triptych = useTriptych()

  const [create, { isLoading, error: apiErrors }] = tagApi.useCreateOneTagMutation();

  const formMethods = useForm<TagFormValues>({
    resolver: classValidatorResolver(TagDTO),
    defaultValues: {
      name: '',
      description: '',
      color: '#000',
      position: 0,
      products: []
    },
  });

  // @ts-ignore
  useUpdateCardData(formMethods, ['name']);

  const onCreate = async (formValues: TagFormValues) => {
    try {
      const tag = await create(transformStepFormValuesToPayload(formValues)).unwrap();

      triptych.close({ mode: 'UPDATE', data: tag });

      toast.success('Votre catégorie a bien été ajoutée.')
    } catch {
      toast.error('Une erreur est survenue lors de la création de votre catégorie.')
    }
  }

  return (
    <Panel.Content>

      <Form formMethods={formMethods} apiErrors={apiErrors}>

        <Panel.FormContainer>

          <TagForm />

        </Panel.FormContainer>

        <Panel.Actions>
          <Button
            title="Retour"
            grow
            large
            bordered
            onPress={() => triptych.close()} />

          <Button
            loading={isLoading}
            title="Valider"
            onPress={formMethods.handleSubmit(onCreate)}
            grow
            large />
        </Panel.Actions>

      </Form>

    </Panel.Content>
  );
});
